import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9faba716"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tile-layout cols" }
const _hoisted_2 = { class: "tile-title" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = {
  key: 0,
  style: {"margin-right":"16px"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"4px"} }, "Detail", -1))
const _hoisted_7 = {
  key: 0,
  class: "k-icon k-i-download"
}
const _hoisted_8 = {
  key: 1,
  class: "k-icon k-font-icon k-i-loading"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"4px"} }, "Summary", -1))
const _hoisted_12 = {
  key: 0,
  class: "k-icon k-i-download"
}
const _hoisted_13 = {
  key: 1,
  class: "k-icon k-font-icon k-i-loading"
}
const _hoisted_14 = { class: "tile-body" }

import {
  ProductivityType,
  ProductivityLevel,
} from "@/core/types/dashboard/ProductivityData";
import { computed, ref } from "vue";

type Tile = {
  position: number;
  header: string;
  body: string;
};

type Props = {
  columns: number;
  tiles: Array<Tile>;
  level: ProductivityLevel;
  productivityDataFecther: (
    type: ProductivityType,
    detailVersion: boolean,
  ) => Promise<void>;
};


const __default__ = {
  name: "TileLayout",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    columns: null,
    tiles: null,
    level: null,
    productivityDataFecther: null
  },
  setup(__props: any) {

const props = __props as {
  columns: number;
  tiles: Array<Tile>;
  level: ProductivityLevel;
  productivityDataFecther: (
    type: ProductivityType,
    detailVersion: boolean,
  ) => Promise<void>;
}

_useCssVars(_ctx => ({
  "35578732": (_unref(cols))
}))


const tiles = computed(() => {
  const tiles = [...props.tiles];
  tiles.sort((a, b) => a.position - b.position);

  return tiles;
});
const isDownloading = ref(false);

const cols = computed(() => Math.min(Math.max(0, props.columns), 12));
const isLastTile = (tile: Tile) => tile.position === tiles.value.length - 1;
const isNonProduction = (level: ProductivityLevel) =>
  level === ProductivityLevel.NonProduction;

const hasSummaryDownload = (tile: Tile, level: ProductivityLevel) =>
  !isLastTile(tile) && !isNonProduction(level);

const hasDetailDownload = (tile: Tile, level: ProductivityLevel) =>
  hasSummaryDownload(tile, level) &&
  [
    ProductivityLevel.General,
    ProductivityLevel.Magnum,
    ProductivityLevel.Consolidated,
  ].includes(level);

const onDownload = async (tile: Tile, detailVersion: boolean) => {
  try {
    isDownloading.value = true;
    await props.productivityDataFecther(
      tile.position as ProductivityType,
      detailVersion,
    );
  } catch (error) {
    console.error(error);
  } finally {
    isDownloading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tiles), (tile) => {
      return (_openBlock(), _createElementBlock("div", {
        key: tile.position,
        class: "tile"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(tile.header), 1),
          _createElementVNode("div", _hoisted_3, [
            (hasDetailDownload(tile, props.level))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("a", {
                    class: "download-button",
                    title: "Detail",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (onDownload(tile, true)), ["prevent"])
                  }, [
                    _hoisted_6,
                    (!isDownloading.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8))
                  ], 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            (hasSummaryDownload(tile, props.level))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("a", {
                    class: "download-button",
                    title: "Summary",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (onDownload(tile, false)), ["prevent"])
                  }, [
                    _hoisted_11,
                    (!isDownloading.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13))
                  ], 8, _hoisted_10)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _renderSlot(_ctx.$slots, tile.body)
        ])
      ]))
    }), 128))
  ]))
}
}

})